import React, { ReactNode } from 'react'
import styles from './BlockTypeButton.module.scss'

interface IBlockTypeButton {
  text: string
  icon: ReactNode
  onClick: any
  className?: string
  disabled?: boolean
}

const BlockTypeButton: React.FC<IBlockTypeButton> = ({
  text,
  icon,
  onClick,
  className = '',
  disabled = false,
}) => {
  return (
    <a
      className={`d-flex flex-column align-items-center ${className} ${styles.optionBlockButton}`}
      onClick={() => !disabled && onClick()}
    >
      <span className={`${styles.blockOptionIconContainer}`}>{icon}</span>
      {text}
    </a>
  )
}

export default BlockTypeButton
